import { render } from "./RichTableCard.vue?vue&type=template&id=02513de0&scoped=true"
import script from "./RichTableCard.vue?vue&type=script&lang=js"
export * from "./RichTableCard.vue?vue&type=script&lang=js"

import "./RichTableCard.vue?vue&type=style&index=0&id=02513de0&lang=sass&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02513de0"]])

export default __exports__